export default {
  state: {
    foregroundLoading: 0,
    backgroundLoading: 0
  },
  getters: {
    anyLoading(state) {
      return state.foregroundLoading > 0 || state.backgroundLoading > 0;
    },
  },
  mutations: {
    startForegroundLoading(state) {
      state.foregroundLoading++;
    },
    finishForegroundLoading(state) {
      state.foregroundLoading--
    },
    startBackgroundLoading(state) {
      state.backgroundLoading++;
    },
    finishBackgroundLoading(state) {
      state.backgroundLoading--
    },
  },
  actions: {
    startForegroundLoading(context) {
      context.commit('startForegroundLoading');
    },
    finishForegroundLoading(context) {
      context.commit('finishForegroundLoading');
    },
    startBackgroundLoading(context) {
      context.commit('startBackgroundLoading');
    },
    finishBackgroundLoading(context) {
      context.commit('finishBackgroundLoading');
    },
  }
};